import React from "react";
import "./BrandCarousel.css";

export default function BrandCarousel() {
  // Uses existing images so it works immediately; replace/extend as needed
  const logos = [
    "/assets/smartvaathi/smartvaathi-logo.png",
    "/assets/starbit/starbit-logo.png",
    "/assets/wildasia/wildasia-logo.png",
    "/assets/showzs/showzs-logo.png",
    "/assets/luggage-corner/luggage-corner-logo.png",
    "/assets/singhesuppliers/singhesuppliers-logo.png",
  ];

  if (!logos.length) return null;

  // Duplicate list for seamless loop
  const loopLogos = [...logos, ...logos];

  return (
    <div className="brand-carousel">
      <div className="brand-track">
        {loopLogos.map((src, idx) => (
          <div className="brand-item" key={idx}>
            <img src={src} alt="brand logo" loading="lazy" />
          </div>
        ))}
      </div>
    </div>
  );
}


